
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Template from '@ckeditor/ckeditor5-ui/src/template';

export default class HSButtonUI extends Plugin {
    init() {

        const editor = this.editor;
        const t = editor.t;
				const hsButtonOptions = editor.config.get("hsButtonOptions");
				if(hsButtonOptions == undefined){
					return;
				}

        // The "hsButton" button must be registered among the UI components of the editor
        // to be displayed in the toolbar.
        editor.ui.componentFactory.add( 'hsButton', locale => {
            // The state of the button will be bound to the widget command.
            const command = editor.commands.get( 'insertHSButton' );

            // The button will be an instance of ButtonView.
            const buttonView = new ButtonView( locale );

            buttonView.set( {
                // The t() function helps localize the editor. All strings enclosed in t() can be
                // translated and change when the language of the editor changes.
                label: hsButtonOptions.label,
								icon: hsButtonOptions.svg,
								class: 'required',
                withText: true,
                tooltip: hsButtonOptions.tooltip || hsButtonOptions.label
            } );

            // Bind the state of the button to the command.
            buttonView.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' );

            // Execute the command when the button is clicked (executed).
            this.listenTo( buttonView, 'execute', () => editor.execute( 'insertHSButton' ) );
						
						editor.model.document.on( 'change:data', () => {
							const hsButtons = findNodes(editor.model, 'hsButton', editor.model.document.getRoot());
							
							buttonView.set( {
                // The t() function helps localize the editor. All strings enclosed in t() can be
                // translated and change when the language of the editor changes.
								class: hsButtons.length >= hsButtonOptions.numButtonsRequired ? '' : 'required',
							});
						});
            return buttonView;
        } );
    }
}

const findNodes = function(model, type, root) {
    const nodes = [];
		const range = model.createRangeIn(model.document.getRoot());
    for ( const value of range.getWalker({ ignoreElementEnd: true }) ) {
        const node = value.item;
        if ( node.is('element', type ) ) {
            nodes.push(node);
        }
    }
    return nodes;
};